<template>
  <div :class="[own ? 'message own' : 'message']">
    <div class="messageTop">
      <img
        v-if="!own"
        class="messageImg mt-2"
        :src="profileImg"
        alt=""
      />
      <p class="messageText">
        {{ message.text }}
      </p>
    </div>
    <div :class="[own ? 'messageBottom own mt-n5 ' : 'messageBottom mt-n5 ml-2']">{{time}}</div>
  </div>
</template>

<script>
import { format } from "timeago.js";

export default {
  props: {
    message: {
      type: Object,
      default: () => {},
    },

    profileImg: {
      type: String,
      default: "require(@/assets/default.png)"
    },

    own: {
      type: Boolean,
    },

  },

  data() {
    return {};
  },

  computed: {
    time(){
      return format(this.message.createdAt)
    }
  },

  created() {},
};
</script>

<style>
.message {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
}

.messageTop {
  display: flex;
  padding: 10px
}

.messageImg {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.messageText {
  padding: 10px;
  border-radius: 20px;
  background-color: rgb(245, 241, 241);
  color: black;
  max-width: 300px;
  align-items: center;
}

.messageBottom {
  font-size: 12px;
  margin-top: 10px;
}

.message.own {
  align-items: flex-end;
}

.message.own .messageText {
  background-color: #1877f2;
  color: white;
}
</style>
